import RequestManagerWrapper from './RequestManagerWrapper';

export default RequestManagerWrapper;
